var map = {
	"./DOC.png": "7a2c",
	"./DOCX.png": "1ffe",
	"./KEY.png": "7ca4",
	"./PDF.png": "4d45",
	"./PGS.png": "b4e1",
	"./PPT.png": "4047",
	"./PPTX.png": "d975",
	"./TXT.png": "6c35",
	"./WPS.png": "d35c",
	"./add-icon.png": "42f5",
	"./arrow-icon.png": "bbff",
	"./arrow001.png": "692f",
	"./arrow002.png": "084d",
	"./arrow003.png": "c579",
	"./arrow004.png": "bc9a",
	"./arrow005.png": "b5ae5",
	"./atom-control-frequency.png": "aca8",
	"./atom-control-list.png": "252b",
	"./atom-control-rule.png": "41e9",
	"./atom-control-time.png": "20b7",
	"./atom-copy-icon.png": "b6ea",
	"./atom-customized-removal.png": "4be0",
	"./atom-default-rule.png": "716d",
	"./atom-delete-icon.png": "925a",
	"./atom-detail-icon.png": "ba73",
	"./atom-edit-icon.png": "91b9",
	"./atom-filtertime-control.png": "661e",
	"./atom-lock-icon.png": "2f3d",
	"./atom-logo.png": "ed45",
	"./atom-strategy-type.png": "25fb",
	"./atom-tag-sync-mgt.png": "ad00",
	"./atom-task-reminder.png": "75e7",
	"./atom-tool-icon.png": "33cd",
	"./atom-toufang-icon.png": "b394",
	"./atom_side_logo.png": "bdc4",
	"./atom_white.png": "87b39",
	"./awator.png": "01e8",
	"./baby-industry-icon.png": "d380",
	"./beauty-industry-icon.png": "6de6",
	"./buffer_icon.png": "7748",
	"./calendar.png": "2cc6",
	"./contract-icon.png": "4a28",
	"./copy-icon.png": "2536",
	"./default_docs.png": "6a47",
	"./delete-icon.png": "1e8f",
	"./detail-icon.png": "920b",
	"./download.png": "f6f5",
	"./edit-icon.png": "a16a",
	"./expand-icon.png": "9baf",
	"./home-logo.png": "3989",
	"./home_nor.png": "f819",
	"./home_selected.png": "3d4c",
	"./horizontal-line.png": "969e0",
	"./iphone.png": "c4cb",
	"./left-bottom-arrow.png": "cc7e",
	"./left-top-arrow.png": "0d43",
	"./lock-icon.png": "9053",
	"./mcd-control-frequency.png": "52945",
	"./mcd-control-list.png": "d81c",
	"./mcd-control-rule.png": "1031",
	"./mcd-control-time.png": "edb4",
	"./mcd-customized-removal.png": "eea5",
	"./mcd-default-rule.png": "ed36",
	"./mcd-filtertime-control.png": "8df5",
	"./mcd-logo.png": "01c0",
	"./mcd-strategy-type.png": "65cb",
	"./mcd-tag-sync-mgt.png": "621d",
	"./mcd-task-reminder.png": "bcea",
	"./pie-icon.png": "29c5",
	"./process-commit.png": "95d7",
	"./process-failure.png": "494c",
	"./process-loading.png": "f71a",
	"./process-success.png": "b02f",
	"./redo_dis_icon.png": "1071",
	"./redo_icon.png": "b346",
	"./remove-icon.png": "62f5",
	"./retail-industry-icon.png": "a48f",
	"./right-bottom-arrow.png": "807c",
	"./search-icon.png": "1c4e",
	"./straight-arrow-new.png": "abe2",
	"./straight-arrow.png": "daac",
	"./task-icon.png": "ce3b",
	"./tool-icon.png": "5b65",
	"./top-right-arrow.png": "5750",
	"./toufang-icon.png": "d9d8",
	"./trend-chart-icon-1.png": "cc66",
	"./trend-chart-icon-2.png": "6458",
	"./trend-chart-icon-3.png": "34a7",
	"./trend-chart-icon-4.png": "c701",
	"./trend-chart-icon-5.png": "6980",
	"./undo_dis_icon.png": "b8bf",
	"./undo_icon.png": "e114",
	"./wasr-industry-icon.png": "43e0",
	"./yoplait-control-frequency.png": "c30d",
	"./yoplait-control-list.png": "2ae6",
	"./yoplait-control-rule.png": "2f0d",
	"./yoplait-control-time.png": "eea8",
	"./yoplait-customized-removal.png": "1948",
	"./yoplait-default-rule.png": "0d4d",
	"./yoplait-filtertime-control.png": "6b82",
	"./yoplait-logo.png": "096e",
	"./yoplait-strategy-type.png": "6673",
	"./yoplait-tag-sync-mgt.png": "73dc",
	"./yoplait-task-reminder.png": "5545"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";